export default {"src":"/_next/static/media/bg-lg.a436067b.svg","height":350,"width":1920,"blurWidth":0,"blurHeight":0};